/**
 * Estonian (et) locale for the Keeris MiniApp UI.
 * The Curator Dev Console remains in English and is not included here.
 */
export const et = {
  // ── App shell (App.vue) ──────────────────────────────────────────────────
  app: {
    brand: 'ERR arhiivi otsing',
    nav: {
      songs: 'Otsing',
      summary: 'Saatesarjad',
      playlists: 'Esitusloendid',
    },
    exportDb: 'Ekspordi DB',
    exportingDb: 'Eksporditakse...',
    importDb: 'Impordi DB',
    importingDb: 'Imporditakse...',
    importConfirm: "Impordi '{name}' ({size} MB) salvestusruumi? See asendab praeguse andmebaasi ja laeb lehe uuesti.",
    exportError: 'Eksportimine ebaõnnestus: {msg}',
    importError: 'Importimine ebaõnnestus: {msg}',
    devConsole: 'Kuraatori konsool',
    themeToggle: 'Vaheta välimust',
    themeDark: 'Tume',
    themeLight: 'Hele',
  },

  // ── TrackTable.vue ───────────────────────────────────────────────────────
  trackTable: {
    searchPlaceholder: 'Otsi loo pealkirja, esitajat või saate teksti (nt Remedium, Keeris, Kauamängiv)...',
    filterTitle: 'Saatesarjad',
    filterAll: '{n} saadet',
    filterSelected: 'leitud {selected} / {total} saate seast',
    collapseFilters: 'Sulge filtrid ▲',
    expandFilters: 'Ava filtrid ▼',
    chipCounts: '{eps} episoodi · {tracks} lugu',
    statsSearch: '{unique} unikaalset lugu · {airings} esitust {episodes} saates',
    statsSearchHint: '(kokku {totalUnique} lugu · {totalAirings} eetriaja kataloogis)',
    statsAll: '{unique} unikaalset lugu · {airings} esitust {episodes} saates',
    loading: 'Laen kataloogi...',
    noResults: 'Päringule „{query}" vastavaid lugusid ei leitud.',
    untitledSong: 'Pealkirjata lugu',
    unknownArtist: 'Tundmatu esitaja',
    episodeMatch: 'Saateid',
    playedBadge: 'Esitatud {n}x ➔',
    playedBadgeNoLink: 'Esitatud {n}x',
    playedOnce: 'Esitatud 1x',
    matchInNotes: 'Leitud saate tekstist:',
    addToPlaylist: '+ Esitusloend',
    listen: 'Kuula',
    episodePage: 'Saade ➔',
    trackPos: '{pos}. lugu',
    moreAirings: '+ veel {n} esitust ↓',
    moreAiring: '+ veel {n} esitust ↓',
    fewerAirings: 'Näita vähem  ↑',
    addedToPlaylist: 'Lisatud „{title}"!',
  },

  // ── ProgramSummary.vue ───────────────────────────────────────────────────
  programSummary: {
    heading: 'Saatesarjad',
    subtext: 'Indekseeritud saatesarjade ülevaade',
    statUnique: 'lugu',
    statAirings: 'esitust',
    statEpisodes: 'saadet',  
    statPrograms: 'saatesarja',
    loadingPrograms: 'Laadin saateid...',
    noBreakdown: 'Saadete ülevaade pole veel saadaval.',
    seriesId: 'Saatesarja tunnus: {id}',
    exploreProgram: 'Vaata lähemalt ➔',
    uniqueDensity: 'unikaalsus: {pct}%',
    episodeIndexSub: 'Sirvi saateid, mine otse ERR eetrivoogu või vaata analüüsitud esitusloendit.',
    allShows: 'Kõik saated ({n})',
    filterEpisodesPlaceholder: 'Filtreeri saateid kuupäeva (nt 2024-09), pealkirja või märksõnade järgi...',
    showingEpisodes: 'Kuvatakse {n} saadet ',
    showingEpisodesIn: 'Kuvatakse {n} saadet saatesarjas',
    loadingEpisodes: 'Laadin saateid...',
    noEpisodes: 'Otsingule vastavaid saateid ei leitud.',
    resetFilters: 'Lähtesta filtrid',
    listenOnErr: 'Kuula ERR Arhiivis',
    episodePage: 'Episoodi leht',
    inspectTracklist: '▼ Vaata esitusloendit',
    hideTracklist: '▲ Peida esitusloend',
    loadingTracks: 'Laadin episoodi lugusid...',
    noTracks: 'Selle episoodi jaoks pole lugusid veel indekseeritud.',
    thArtist: 'Esitaja',
    thSongTitle: 'Loo pealkiri',
    thAction: 'Toiming',
    searchLink: 'Otsi ➔',
  },

  // ── ProgramDetail.vue ────────────────────────────────────────────────────
  programDetail: {
    backToSummary: '« Tagasi',
    loadingProgram: 'Laen saatesarja andmeid...',
    programNotFound: 'Saatesarja ei leitud',
    programNotFoundDesc: 'Ei leia saatesarja tunnusega „{id}".',
    returnToSummary: 'Tagasi ülevaatesse',
    errArchivePage: 'ERR Arhiivi leht',
    exploreSongs: 'Otsi lugusid',
    metricEpisodes: 'saadet',
    metricTracks: 'esitust',
    metricUnique: 'lugu',
    tracksCount: '{n} lugu',
    broadcastEpisodes: 'Saated ({n})',
    broadcastSubtext: 'saatesarja saadete nimekiri.',
    searchEpisodesPlaceholder: 'Otsi saateid kuupäeva või pealkirja järgi...',
    noEpisodesFound: 'Päringule „{query}" vastavaid saateid ei leitud.',
    listenOnErr: 'Kuula saadet ➔',
    episodePage: 'Saate info ➔',
    showTracks: '▼ Vaata lugusid',
    hideTracks: '▲ Sulge',
    loadingTracklist: 'Laen esitusloendi ...',
    noTracksIndexed: 'Selle saate all ei ole indekseeritud lugusid.',
    thArtist: 'Esitaja',
    thTitle: 'Pealkiri',
    thActions: 'Toimingud',
    addToPlaylist: '+ Esitusloend',
    search: 'Otsi',
    addedToPlaylist: 'Lisatud „{title}"!',
  },

  // ── EpisodeDetail.vue ────────────────────────────────────────────────────
  episodeDetail: {
    backToProgram: 'Tagasi: {title}',
    backToPrograms: 'Tagasi saatesarjade juurde',
    loadingEpisode: 'Laen saate andmeid...',
    episodeNotFound: 'Saadet ei leitud',
    episodeNotFoundDesc: 'Ei leia saadet tunnusega „{id}".',
    returnToSummary: ' Tagasi',
    tracksIndexed: '{n} indekseeritud lugu',
    listenOnErr: 'Kuula ',
    searchInCatalog: 'Otsi ',
    broadcastNotes: 'Saate märkmed:',
    tracklistTitle: 'Episoodi esitusloend ({n})',
    loadingTracks: 'Laadin lugusid...',
    noTracklist: 'Selle eetrisaate jaoks pole esitusloendi kirjeid indekseeritud.',
    thArtist: 'Esitaja / Esineja',
    thTitle: 'Loo pealkiri',
    thActions: 'Toimingud',
    addToPlaylist: '+ Esitusloend',
    search: 'Otsi',
    addedToPlaylist: 'Lisatud „{title}"!',
  },

  // ── AddToPlaylistDialog.vue ──────────────────────────────────────────────
  addToPlaylist: {
    dialogTitle: 'Lisa esitusloendisse',
    untitledTrack: 'Pealkirjata lugu',
    unknownArtist: 'Tundmatu esitaja',
    selectLabel: 'Vali sihtesitusloend:',
    choosePlaceholder: 'Vali esitusloend...',
    trackCount: '{n} lugu',
    noPlaylists: 'Sul pole veel ühtegi esitusloendi. Loo üks allpool, et see lugu salvestada!',
    useExisting: 'Kasuta olemasolevat esitusloendi',
    createNew: '+ Loo uus esitusloend',
    newTitleLabel: 'Uue esitusloendi pealkiri',
    newTitlePlaceholder: 'nt Minu ERR lemmikud',
    newDescLabel: 'Kirjeldus (valikuline)',
    newDescPlaceholder: 'nt Parimad lood 1980ndate raadiost',
    trackNotesLabel: 'Märkmed loo kohta (valikuline)',
    trackNotesPlaceholder: 'nt Avastatud 1982. aasta episoodis, suurepärane bassiliini',
    cancel: 'Tühista',
    addTrack: 'Lisa lugu',
    savedTo: 'Lisatud „{title}"!',
    saveFailed: 'Salvestamine esitusloendisse ebaõnnestus',
  },

  // ── PlaylistManager.vue ──────────────────────────────────────────────────
  playlistManager: {
    // Detail view header
    allPlaylists: 'Kõik esitusloendid',
    tracksUpdated: '{n} lugu · Uuendatud {date}',
    copyMarkdown: 'Kopeeri Markdown',
    copied: 'Kopeeritud! ✔',
    downloadMd: 'Laadi alla .md',
    customTrack: 'Kohandatud lugu',
    delete: 'Kustuta',
    filterTracksPlaceholder: 'Filtreeri lugusid pealkirja, esitaja, saate või märkmete järgi...',
    noTracksYet: 'Selles esitusloendis pole veel lugusid.',
    noTracksHint: 'Lisa laule „{songsTab}" vahelehelt nupuga „+ Esitusloend" või klõpsa „Kohandatud lugu", et lisada käsitsi.',
    songsTabName: 'Laulud & Eetriajad',
    addCustomTrack: 'Lisa kohandatud lugu',
    noTrackMatch: 'Päringule „{q}" vastavaid lugusid ei leitud.',
    trackPos: '(#{pos}. lugu)',
    unknownArtist: 'Tundmatu esitaja',
    sourceEpisode: 'Allikaepisood',
    notes: 'Märkmed:',

    // Overview
    curatedPlaylists: 'Koostatud esitusloendid',
    playlistCount: '({n} esitusloendi · {tracks} lugu kohalikus salvestuses)',
    newPlaylist: 'Uus esitusloend',
    exportAll: 'Ekspordi kõik (MD)',
    backupJson: 'Varunda JSON',
    importJson: 'Impordi JSON',
    noPlaylistsTitle: 'Ühtegi esitusloendi veel pole',
    noPlaylistsDesc: 'Loo esitusloend ERR arhiivisaadete lugude ja metaandmete koostamiseks. Esitusloendid salvestatakse lokaalselt sinu brauserisse ja neid saab eksportida struktureeritud Markdown failidena.',
    createFirstPlaylist: 'Loo esimene esitusloend',
    noDescription: 'Kirjeldus puudub.',
    updatedAt: 'Uuendatud {date}',
    openAndCurate: 'Ava & Koosta',
    track: 'lugu',
    tracks: 'lugu',

    // Dialogs
    createDialogTitle: 'Loo uus esitusloend',
    playlistTitleLabel: 'Esitusloendi pealkiri',
    playlistTitlePlaceholder: 'nt Eesti 80ndate funk valikud',
    descLabel: 'Kirjeldus (valikuline)',
    descPlaceholder: 'nt Koostatud lood Keerise ja Kauamängiva episoodidest',
    cancel: 'Tühista',
    create: 'Loo',

    editDialogTitle: 'Muuda esitusloendi andmeid',
    saveChanges: 'Salvesta muudatused',

    addCustomTrackTitle: 'Lisa kohandatud lugu',
    songTitleLabel: 'Loo pealkiri *',
    songTitlePlaceholder: 'nt Virmalised',
    artistLabel: 'Esitaja / Bänd',
    artistPlaceholder: 'nt Keeris',
    programLabel: 'Saade (valikuline)',
    programPlaceholder: 'nt Keeris või Kauamängiv',
    episodeTitleLabel: 'Episoodi pealkiri (valikuline)',
    episodeTitlePlaceholder: 'nt Keeris: 14.05.1982',
    episodeUrlLabel: 'Episoodi / arhiivi URL (valikuline)',
    episodeUrlPlaceholder: 'https://arhiiv.err.ee/audio/vaata/...',
    notesLabel: 'Märkmed / kommentaar (valikuline)',
    notesPlaceholder: 'Lisa märkmed, ajatempel või highlights',
    addToPlaylistBtn: 'Lisa esitusloendisse',

    editNotesTitle: 'Muuda loo märkmeid',
    editNotesLabel: 'Märkmed / kommentaar',
    editNotesPlaceholder: 'Sisesta isiklikud märkmed, groovi kirjeldus või kontekst',
    save: 'Salvesta',

    deleteTitle: 'Kustuta esitusloend?',
    deleteConfirm: 'Kas oled kindel, et soovid kustutada esitusloendi „{title}"? See toiming eemaldab kõik {n} koostatud lugu kohalikust salvestusest.',

    exportAllTitle: 'Ekspordi kõik esitusloendid (Markdown)',
    exportAllDesc: 'Struktureeritud Markdown klikitavate ERR arhiivi linkide, eetrikuupäevade ja loo metaandmetega:',
    copyToClipboard: 'Kopeeri lõikelauale',

    importTitle: 'Impordi esitusloendid JSON-ist',
    importDesc: 'Vali eelnevalt eksporditud Keerise esitusloendi varukoopia JSON fail või kleebi JSON alla:',
    uploadJsonLabel: 'Laadi üles JSON fail',
    pasteJsonLabel: 'Või kleebi JSON otse',
    mergeMode: 'Ühenda olemasolevaga',
    replaceMode: 'Asenda kõik olemasolevad',
    import: 'Impordi',

    // Toasts
    toastCreated: 'Esitusloend „{title}" loodud!',
    toastUpdated: 'Esitusloendi andmed uuendatud',
    toastDeleted: 'Esitusloend „{title}" kustutatud',
    toastCustomAdded: 'Kohandatud lugu lisatud esitusloendisse',
    toastNotesUpdated: 'Loo märkmed uuendatud',
    toastMarkdownCopied: 'Markdown kopeeritud lõikelauale!',
    toastImportedPlaylists: '{n} esitusloendi imporditud',
    toastImportFailed: 'Importimine ebaõnnestus: {msg}',
    toastTrackRemoved: 'Lugu eemaldatud esitusloendist',
  },
};
